import { useEffect } from 'react';

import { useAppDispatch } from 'app/hooks';

import { useUser } from 'selectors/userSelectors';
import TestComponent from './TestComponent';

import './Test.scss';

function TestPage(props: {}) {
  const { user } = useUser();
  const dispatch = useAppDispatch();

  // fetch dialogue 3, phase 3, list block 2
  useEffect(() => {
  }, [dispatch]);

  return (
    <>
      <div>Hello {user?.username}</div>
      <div>Test page content goes here</div>
      <TestComponent />
    </>
  );
}

export default function Test(props: {}) {
  const {} = props;

  return (
    <>
      <div className="static_page test">
        <TestPage {...props} />
      </div>
    </>
  );
}
